import React from "react";
import "./s.badge.css";


export function Badge(props: {
    className?: string;
    children?: any;
    onClick?: (e: React.MouseEvent) => any;
}) {
    return (
        <div
            className={"badge" + (props.className ? " " + props.className : "")}
            onClick={props.onClick}
        >
            {props.children}
        </div>
    );
}
